<template>
  <div id="main" class="ssss" v-loading="loading">
    <div class="acc">
      <div class="op">
        <Candode v-on:childByValue="childByValue" ></Candode>
        <div class="add">
          <el-date-picker
            v-model="time"
            size='mini'
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format = "yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="add" >
          <el-select size="mini" v-model="cblx" placeholder="补贴类型">
            <el-option
              v-for="item6 in cblxList"
              :key="item6.value"
              :label="item6.label"
              :value="item6.value">
            </el-option>
          </el-select>
        </div>
        <div class="add">
          <ageList v-on:ageListEvent="ageListEvent" />
          <el-select size="mini" clearable v-model="age" placeholder="选择年龄">
            <el-option
              v-for="item4 in ageList"
              :key="item4.value"
              :label="item4.label"
              :value="item4.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">查询</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      stripe>
      <el-table-column
        prop="areaName"
        label="地区"
        >
      </el-table-column>
      <el-table-column
        prop="allCount"
        label="总数"
        >
      </el-table-column>
      <el-table-column
        prop="authCount"

        label="认证数">
      </el-table-column>
      <el-table-column
        prop="noauthCount"
        label="未认证">
      </el-table-column>
      <el-table-column
        prop="rate"

        label="认证比例">
      </el-table-column>
    </el-table>

    <el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px;float: right" icon="el-icon-download" @click="toExcel">导出</el-button>
  </div>
</template>
<script>
import Candode from "../Core/candode";
import { getType } from "../../utils/typeAuth";
import ageList from "../../utils/ageList.vue";
import baseUrl from "../../utils/global";
import { Loading } from "element-ui";

export default {
  components: {
    Candode,
    ageList
  },
  data() {
    return {
      loading: false,
      tableData: [],
      cblx: "",
      cblxList: [],
      ageList: [],
      townList: [],
      age: "",
      time: "",
      province: "",
      city: "",
      county: "",
      town: "",
      village: "",
      birthday: "",
      start_time: "",
      end_time: "",
      verify_type: "",
      year: new Date().getFullYear(),
      pickerOptions: {
        shortcuts: [
          {
            text: "1月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 0, 1);
              const end = new Date(year, 1, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "2月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 1, 1);
              const end = new Date(year, 2, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 2, 1);
              const end = new Date(year, 3, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "4月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 3, 1);
              const end = new Date(year, 4, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "5月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 4, 1);
              const end = new Date(year, 5, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 5, 1);
              const end = new Date(year, 6, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "7月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 6, 1);
              const end = new Date(year, 7, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "8月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 7, 1);
              const end = new Date(year, 8, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "9月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 8, 1);
              const end = new Date(year, 9, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "10月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 9, 1);
              const end = new Date(year, 10, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "11月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 10, 1);
              const end = new Date(year, 11, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "12月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 11, 1);
              const end = new Date(year, 12, 0);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    serch() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";

      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      console.log(this.time);
      this.loading = true;
      let data = {
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        birthday: this.age,
        start_time: this.time ? this.time[0] : "",
        end_time: this.time ? this.time[1] : "",
        verify_type: this.cblx
      };
      this.$api.getlist
        .getAuthRate(data)
        .then(res => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch(res => {
          this.loading = false;
          this.$message(JSON.stringify(res));
        });
    },
    toExcel() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";

      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      let data = {
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        birthday: this.age,
        start_time: this.time ? this.time[0] : "",
        end_time: this.time ? this.time[1] : "",
        verify_type: this.cblx
      };
      this.$api.getlist
        .exportAuthRate(data)
        .then(res => {
          var that = this;
          if (res.code == 200) {
            this.loading = false;
            window.location.href =
              baseUrl.baseUrl + "/download/excel?fileName=" + res.result;
          } else {
            this.loading = false;
            this.$message(res.describe);
          }
        })
        .catch(res => {
          console.log(res);
          this.$message("导出失败");
          this.loading = false;
        });
    },
    ageListEvent(s) {
      console.log(s);
      this.ageList = s;
    },
    childByValue(val) {
      this.townList = val;
    }
  },
  created() {
    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
      arr.unshift("");
    }
    for (let i in arr) {
      this.cblxList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.cblx = arr[0];
  },
  destroyed() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/authRate.vue